import React from 'react';

const PageHeader = ({ title, subtitle, action }) => (
  <div className="flex flex-wrap items-start justify-between gap-4 mb-6">
    <div>
      <h1 className="text-2xl font-semibold text-slate-900">{title}</h1>
      {subtitle && <p className="text-slate-600 text-sm mt-1">{subtitle}</p>}
    </div>
    {action}
  </div>
);

export const btnPrimary =
  'inline-flex items-center bg-teal-700 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-teal-800';

export const btnSecondary =
  'inline-flex items-center border border-slate-300 text-slate-700 px-4 py-2 rounded-lg text-sm font-medium hover:bg-slate-50';

export const inputClass =
  'w-full border border-slate-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500';

export const cardClass = 'bg-white rounded-xl shadow border border-slate-100';

export default PageHeader;
